function mapDiscount(discountApplications){
            return discountApplications.map(x => {
                        return {
                                    code: x.code,
                                    amount: x.value.amount ? -parseFloat(x.value.amount) : 0,
                                    percentage: x.value.percentage ? -parseInt(x.value.percentage) * .01 : 0
                        }
            })
}

export default mapDiscount;

// const sampleProduct = {
//             "id": "Z2lkOi8vc2hvcGlmeS9DaGVja291dC81NjU5ZmU4MTkzNGYwZTk5MmZlNzFmZWEwY2FkYzUxYj9rZXk9MDE2OTM4YTk3YzRhOTRmZTZiMTg5MGRlMjM2M2RmZDA=",
//             "ready": true,
//             "requiresShipping": true,
//             "note": null,
//             "paymentDue": "11.99",
//             "paymentDueV2": {
//                 "amount": "11.99",
//                 "currencyCode": "USD",
//                 "type": {
//                     "name": "MoneyV2",
//                     "kind": "OBJECT",
//                     "fieldBaseTypes": {
//                         "amount": "Decimal",
//                         "currencyCode": "CurrencyCode"
//                     },
//                     "implementsNode": false
//                 }
//             },
//             "webUrl": "https://hbgusa-dev.myshopify.com/60602155168/checkouts/5659fe81934f0e992fe71fea0cadc51b?key=016938a97c4a94fe6b1890de2363dfd0",
//             "orderStatusUrl": null,
//             "taxExempt": false,
//             "taxesIncluded": false,
//             "currencyCode": "USD",
//             "totalTax": "0.00",
//             "totalTaxV2": {
//                 "amount": "0.0",
//                 "currencyCode": "USD",
//                 "type": {
//                     "name": "MoneyV2",
//                     "kind": "OBJECT",
//                     "fieldBaseTypes": {
//                         "amount": "Decimal",
//                         "currencyCode": "CurrencyCode"
//                     },
//                     "implementsNode": false
//                 }
//             },
//             "lineItemsSubtotalPrice": {
//                 "amount": "16.99",
//                 "currencyCode": "USD",
//                 "type": {
//                     "name": "MoneyV2",
//                     "kind": "OBJECT",
//                     "fieldBaseTypes": {
//                         "amount": "Decimal",
//                         "currencyCode": "CurrencyCode"
//                     },
//                     "implementsNode": false
//                 }
//             },
//             "subtotalPrice": "11.99",
//             "subtotalPriceV2": {
//                 "amount": "11.99",
//                 "currencyCode": "USD",
//                 "type": {
//                     "name": "MoneyV2",
//                     "kind": "OBJECT",
//                     "fieldBaseTypes": {
//                         "amount": "Decimal",
//                         "currencyCode": "CurrencyCode"
//                     },
//                     "implementsNode": false
//                 }
//             },
//             "totalPrice": "11.99",
//             "totalPriceV2": {
//                 "amount": "11.99",
//                 "currencyCode": "USD",
//                 "type": {
//                     "name": "MoneyV2",
//                     "kind": "OBJECT",
//                     "fieldBaseTypes": {
//                         "amount": "Decimal",
//                         "currencyCode": "CurrencyCode"
//                     },
//                     "implementsNode": false
//                 }
//             },
//             "completedAt": null,
//             "createdAt": "2022-03-11T11:50:49Z",
//             "updatedAt": "2022-03-11T11:56:41Z",
//             "email": null,
//             "discountApplications": [
//                 {
//                     "__typename": "DiscountCodeApplication",
//                     "targetSelection": "ALL",
//                     "allocationMethod": "ACROSS",
//                     "targetType": "LINE_ITEM",
//                     "value": {
//                         "amount": "5.0",
//                         "currencyCode": "USD",
//                         "type": {
//                             "name": "PricingValue",
//                             "kind": "UNION"
//                         }
//                     },
//                     "code": "5OFF",
//                     "applicable": true,
//                     "type": {
//                         "name": "DiscountCodeApplication",
//                         "kind": "OBJECT",
//                         "fieldBaseTypes": {
//                             "applicable": "Boolean",
//                             "code": "String"
//                         },
//                         "implementsNode": false
//                     },
//                     "hasNextPage": false,
//                     "hasPreviousPage": false,
//                     "variableValues": {
//                         "checkoutId": "Z2lkOi8vc2hvcGlmeS9DaGVja291dC81NjU5ZmU4MTkzNGYwZTk5MmZlNzFmZWEwY2FkYzUxYj9rZXk9MDE2OTM4YTk3YzRhOTRmZTZiMTg5MGRlMjM2M2RmZDA=",
//                         "discountCode": "5OFF"
//                     }
//                 }
//             ],
//             "appliedGiftCards": [],
//             "shippingAddress": null,
//             "shippingLine": null,
//             "customAttributes": [],
//             "order": null,
//             "lineItems": [
//                 {
//                     "id": "Z2lkOi8vc2hvcGlmeS9DaGVja291dExpbmVJdGVtLzQxODE3MDU4MTE1NzQ0MD9jaGVja291dD01NjU5ZmU4MTkzNGYwZTk5MmZlNzFmZWEwY2FkYzUxYg==",
//                     "title": "Delicious Foods",
//                     "variant": {
//                         "id": "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC80MTgxNzA1ODExNTc0NA==",
//                         "title": "Default Title",
//                         "price": "16.99",
//                         "priceV2": {
//                             "amount": "16.99",
//                             "currencyCode": "USD",
//                             "type": {
//                                 "name": "MoneyV2",
//                                 "kind": "OBJECT",
//                                 "fieldBaseTypes": {
//                                     "amount": "Decimal",
//                                     "currencyCode": "CurrencyCode"
//                                 },
//                                 "implementsNode": false
//                             }
//                         },
//                         "weight": 0,
//                         "available": true,
//                         "sku": "9780316284936",
//                         "compareAtPrice": null,
//                         "compareAtPriceV2": null,
//                         "image": {
//                             "id": "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0SW1hZ2UvMzE3MTY2MTc1ODQ4MDA=",
//                             "src": "https://cdn.shopify.com/s/files/1/0606/0215/5168/products/9780316284936.jpg?v=1646412373",
//                             "altText": null,
//                             "width": 298,
//                             "height": 447,
//                             "type": {
//                                 "name": "Image",
//                                 "kind": "OBJECT",
//                                 "fieldBaseTypes": {
//                                     "altText": "String",
//                                     "height": "Int",
//                                     "id": "ID",
//                                     "originalSrc": "URL",
//                                     "src": "URL",
//                                     "width": "Int"
//                                 },
//                                 "implementsNode": false
//                             }
//                         },
//                         "selectedOptions": [
//                             {
//                                 "name": "Title",
//                                 "value": "Default Title",
//                                 "type": {
//                                     "name": "SelectedOption",
//                                     "kind": "OBJECT",
//                                     "fieldBaseTypes": {
//                                         "name": "String",
//                                         "value": "String"
//                                     },
//                                     "implementsNode": false
//                                 }
//                             }
//                         ],
//                         "unitPrice": null,
//                         "unitPriceMeasurement": {
//                             "measuredType": null,
//                             "quantityUnit": null,
//                             "quantityValue": 0,
//                             "referenceUnit": null,
//                             "referenceValue": 0,
//                             "type": {
//                                 "name": "UnitPriceMeasurement",
//                                 "kind": "OBJECT",
//                                 "fieldBaseTypes": {
//                                     "measuredType": "UnitPriceMeasurementMeasuredType",
//                                     "quantityUnit": "UnitPriceMeasurementMeasuredUnit",
//                                     "quantityValue": "Float",
//                                     "referenceUnit": "UnitPriceMeasurementMeasuredUnit",
//                                     "referenceValue": "Int"
//                                 },
//                                 "implementsNode": false
//                             }
//                         },
//                         "product": {
//                             "id": "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0LzcyODA1MzcxMDg2NDA=",
//                             "handle": "delicious-foods-2",
//                             "type": {
//                                 "name": "Product",
//                                 "kind": "OBJECT",
//                                 "fieldBaseTypes": {
//                                     "availableForSale": "Boolean",
//                                     "createdAt": "DateTime",
//                                     "description": "String",
//                                     "descriptionHtml": "HTML",
//                                     "handle": "String",
//                                     "id": "ID",
//                                     "images": "ImageConnection",
//                                     "onlineStoreUrl": "URL",
//                                     "options": "ProductOption",
//                                     "productType": "String",
//                                     "publishedAt": "DateTime",
//                                     "title": "String",
//                                     "updatedAt": "DateTime",
//                                     "variants": "ProductVariantConnection",
//                                     "vendor": "String"
//                                 },
//                                 "implementsNode": true
//                             }
//                         },
//                         "type": {
//                             "name": "ProductVariant",
//                             "kind": "OBJECT",
//                             "fieldBaseTypes": {
//                                 "availableForSale": "Boolean",
//                                 "compareAtPrice": "Money",
//                                 "compareAtPriceV2": "MoneyV2",
//                                 "id": "ID",
//                                 "image": "Image",
//                                 "price": "Money",
//                                 "priceV2": "MoneyV2",
//                                 "product": "Product",
//                                 "selectedOptions": "SelectedOption",
//                                 "sku": "String",
//                                 "title": "String",
//                                 "unitPrice": "MoneyV2",
//                                 "unitPriceMeasurement": "UnitPriceMeasurement",
//                                 "weight": "Float"
//                             },
//                             "implementsNode": true
//                         }
//                     },
//                     "quantity": 1,
//                     "customAttributes": [],
//                     "discountAllocations": [
//                         {
//                             "allocatedAmount": {
//                                 "amount": "5.0",
//                                 "currencyCode": "USD",
//                                 "type": {
//                                     "name": "MoneyV2",
//                                     "kind": "OBJECT",
//                                     "fieldBaseTypes": {
//                                         "amount": "Decimal",
//                                         "currencyCode": "CurrencyCode"
//                                     },
//                                     "implementsNode": false
//                                 }
//                             },
//                             "discountApplication": {
//                                 "__typename": "DiscountCodeApplication",
//                                 "targetSelection": "ALL",
//                                 "allocationMethod": "ACROSS",
//                                 "targetType": "LINE_ITEM",
//                                 "value": {
//                                     "amount": "5.0",
//                                     "currencyCode": "USD",
//                                     "type": {
//                                         "name": "PricingValue",
//                                         "kind": "UNION"
//                                     }
//                                 },
//                                 "code": "5OFF",
//                                 "applicable": true,
//                                 "type": {
//                                     "name": "DiscountCodeApplication",
//                                     "kind": "OBJECT",
//                                     "fieldBaseTypes": {
//                                         "applicable": "Boolean",
//                                         "code": "String"
//                                     },
//                                     "implementsNode": false
//                                 }
//                             },
//                             "type": {
//                                 "name": "DiscountAllocation",
//                                 "kind": "OBJECT",
//                                 "fieldBaseTypes": {
//                                     "allocatedAmount": "MoneyV2",
//                                     "discountApplication": "DiscountApplication"
//                                 },
//                                 "implementsNode": false
//                             }
//                         }
//                     ],
//                     "type": {
//                         "name": "CheckoutLineItem",
//                         "kind": "OBJECT",
//                         "fieldBaseTypes": {
//                             "customAttributes": "Attribute",
//                             "discountAllocations": "DiscountAllocation",
//                             "id": "ID",
//                             "quantity": "Int",
//                             "title": "String",
//                             "variant": "ProductVariant"
//                         },
//                         "implementsNode": true
//                     },
//                     "hasNextPage": false,
//                     "hasPreviousPage": false,
//                     "variableValues": {
//                         "checkoutId": "Z2lkOi8vc2hvcGlmeS9DaGVja291dC81NjU5ZmU4MTkzNGYwZTk5MmZlNzFmZWEwY2FkYzUxYj9rZXk9MDE2OTM4YTk3YzRhOTRmZTZiMTg5MGRlMjM2M2RmZDA=",
//                         "discountCode": "5OFF"
//                     }
//                 }
//             ],
//             "type": {
//                 "name": "Checkout",
//                 "kind": "OBJECT",
//                 "fieldBaseTypes": {
//                     "appliedGiftCards": "AppliedGiftCard",
//                     "completedAt": "DateTime",
//                     "createdAt": "DateTime",
//                     "currencyCode": "CurrencyCode",
//                     "customAttributes": "Attribute",
//                     "discountApplications": "DiscountApplicationConnection",
//                     "email": "String",
//                     "id": "ID",
//                     "lineItems": "CheckoutLineItemConnection",
//                     "lineItemsSubtotalPrice": "MoneyV2",
//                     "note": "String",
//                     "order": "Order",
//                     "orderStatusUrl": "URL",
//                     "paymentDue": "Money",
//                     "paymentDueV2": "MoneyV2",
//                     "ready": "Boolean",
//                     "requiresShipping": "Boolean",
//                     "shippingAddress": "MailingAddress",
//                     "shippingLine": "ShippingRate",
//                     "subtotalPrice": "Money",
//                     "subtotalPriceV2": "MoneyV2",
//                     "taxExempt": "Boolean",
//                     "taxesIncluded": "Boolean",
//                     "totalPrice": "Money",
//                     "totalPriceV2": "MoneyV2",
//                     "totalTax": "Money",
//                     "totalTaxV2": "MoneyV2",
//                     "updatedAt": "DateTime",
//                     "webUrl": "URL"
//                 },
//                 "implementsNode": true
//             },
//             "errors": [
//                 {
//                     "message": "Access denied for order field. Required access: `unauthenticated_read_customers` access scope.",
//                     "locations": [
//                         {
//                             "line": 1,
//                             "column": 2192
//                         }
//                     ],
//                     "path": [
//                         "checkoutDiscountCodeApplyV2",
//                         "checkout",
//                         "order"
//                     ],
//                     "extensions": {
//                         "code": "ACCESS_DENIED",
//                         "documentation": "https://shopify.dev/api/usage/access-scopes",
//                         "requiredAccess": "`unauthenticated_read_customers` access scope."
//                     }
//                 }
//             ],
//             "userErrors": []
//         }